import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Modal,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeader,
} from "../../../Common/styles/modal";
import { DrawerForm } from "../../../Common/styles/drawer";
import { useEffect, useState } from "react";
import {
  CustomModalStepStyle,
  CustomModalStepWrapper,
} from "../../../Common/styles/stepper";
import { errorToastMessage, toastMessage } from "../../../../utils/toast";
import { NoDataContainer } from "../../../Common/styles/table";
import ClosureChecks from "./ClosureChecks";
import ClosureConfirmation from "./ClosureConfirmation";
import { closureChecksList, closureSteps } from "../../../../utils/settings";
import http from "../../../../utils/http";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../Redux/hooks";

const StudyClosureModal = ({ showModal, closeModal }: any) => {
  const { id: studyId } = useParams();
  const studyName = useAppSelector((state) => state.study.name);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitLoader, setSubmitLoader] = useState(false);

  const [activeStep, setActiveStep] = useState<number>(0);
  const [closureData, setClosureData] = useState<any>(
    closureChecksList[activeStep]
  );
  const [currentCheckIndex, setCurrentCheckIndex] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [checksStatusData, setChecksStatusData] = useState<any>(null);

  const handleNext = () => {
    if (activeStep < 2) {
      setClosureData(closureChecksList[activeStep + 1]);
    }
    setCurrentCheckIndex(0);
    setActiveStep((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // const res = await mockApiCall();
        const res = await http.get(`/study/${studyId}/closure-check`);
        setChecksStatusData(res.data.data.actions);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };

    fetchData();
  }, [setLoading, studyId]);

  const handleSubmit = async () => {
    try {
      setSubmitLoader(true);
      const body = {
        studyName: inputValue,
        reason: "Study completion",
        notes: "All criteria met for completion of the study",
      };
      const res = await http.post(`/study/${studyId}/close`, body);
      toastMessage("success", res?.data?.message);
      closeModal();
      navigate("/app/studies");
    } catch (err) {
      setSubmitLoader(false);
      errorToastMessage(err as Error);
    }
  };

  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={ModalDrawerStyles}>
        <ModalHeader title="Study Closure" onCloseClick={closeModal} />
        {!loading ? (
          <Box sx={DrawerForm}>
            <Stepper activeStep={activeStep} sx={CustomModalStepWrapper}>
              {closureSteps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};
                return (
                  <Step key={label} {...stepProps} sx={CustomModalStepStyle}>
                    <StepLabel {...labelProps}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="subtitle1" color="text.secondary">
                          Phase {index + 1}
                        </Typography>
                        <Typography
                          fontWeight={"regular"}
                          variant="h3"
                          color="text.primary"
                        >
                          {label}
                        </Typography>
                      </Box>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            <Box>
              {activeStep === 3 ? (
                <ClosureConfirmation
                  inputValue={inputValue}
                  setInputValue={setInputValue}
                />
              ) : (
                <>
                  {/* {closureData?.desc || ""} */}
                  <Divider sx={{ my: 3 }} />
                  {closureData?.checks && closureData?.checks?.length > 0 && (
                    <ClosureChecks
                      checks={closureData?.checks}
                      currentCheckIndex={currentCheckIndex}
                      setCurrentCheckIndex={setCurrentCheckIndex}
                      checksStatusData={checksStatusData}
                    />
                  )}
                </>
              )}
            </Box>

            <Box sx={{ mt: "auto" }}>
              <Divider />
              <Box sx={ModalDrawerButtonStyles}>
                {!submitLoader ? (
                  <>
                    <Button onClick={closeModal} variant="outlined">
                      Cancel
                    </Button>
                    {closureSteps.length === activeStep + 1 ? (
                      <Button
                        variant="contained"
                        disabled={studyName !== inputValue}
                        onClick={handleSubmit}
                      >
                        Close Study
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        disabled={
                          closureData?.checks?.length !== currentCheckIndex
                        }
                        onClick={handleNext}
                      >
                        Next
                      </Button>
                    )}
                  </>
                ) : (
                  <CircularProgress size={25} />
                )}
              </Box>
            </Box>
          </Box>
        ) : (
          <NoDataContainer>
            <CircularProgress />
          </NoDataContainer>
        )}
      </Box>
    </Modal>
  );
};

export default StudyClosureModal;
